goog.provide("shadow.js.shim.module$$mui$material$RadioGroup");
goog.provide("module$shadow_js_shim_module$$mui$material$RadioGroup");
shadow.js.shim.module$$mui$material$RadioGroup = shadow.js.nativeProvides["@mui/material/RadioGroup"] = shadow$bridge("@mui/material/RadioGroup");
module$shadow_js_shim_module$$mui$material$RadioGroup.default = shadow.js.shim.module$$mui$material$RadioGroup;
